import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Store, User, Lock, Eye, EyeOff } from "lucide-react";

export default function StoreLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = () => {
    setLoading(true);

    setTimeout(() => {
      if (username === "PAT001" && password === "000000") {
        localStorage.setItem("role", "store_manager");
        localStorage.setItem("store_id", "STORE0001");
        navigate("/store/dashboard");
      } else {
        alert("Invalid Store Credentials");
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 p-4">

      <motion.div
        initial={{ opacity: 0, y: 30, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >

        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 shadow-2xl">

          {/* Logo */}
          <div className="flex justify-center mb-4">
            <div className="bg-green-500 p-4 rounded-2xl shadow-lg">
              <Store className="text-white" size={28} />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-center text-white">
            Store Login
          </h2>

          <p className="text-center text-slate-400 text-sm mt-1 mb-6">
            Shruti Eye Care & Opticals
          </p>

          {/* Username */}
          <div className="relative mb-4">
            <User className="absolute left-3 top-3 text-slate-400" size={18} />

            <input
              type="text"
              placeholder="Store Username (e.g. PAT001)"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full pl-10 pr-4 py-3 rounded-xl bg-slate-900 border border-slate-800 text-white placeholder-slate-500 focus:border-green-500 outline-none"
            />
          </div>

          {/* Password */}
          <div className="relative mb-5">
            <Lock className="absolute left-3 top-3 text-slate-400" size={18} />

            <input
              type={showPass ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleLogin()}
              className="w-full pl-10 pr-10 py-3 rounded-xl bg-slate-900 border border-slate-800 text-white placeholder-slate-500 focus:border-green-500 outline-none"
            />

            <button
              type="button"
              onClick={() => setShowPass(!showPass)}
              className="absolute right-3 top-3 text-slate-400"
            >
              {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>

          {/* Login Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleLogin}
            disabled={loading}
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 rounded-xl font-semibold shadow-lg"
          >
            {loading ? "Logging in..." : "Login"}
          </motion.button>

          {/* Footer */}
          <p className="text-center text-xs text-slate-500 mt-5">
            Store Access Portal • ERP System
          </p>

        </div>
      </motion.div>
    </div>
  );
}